module.exports = __webpack_public_path__ + "img/big_1_37.525dbdc2.png";